/* eslint-disable no-unused-vars */
import React, { useRef } from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { GridRow, GridItem } from '@tvg/fuse-design';
import AlertsComponent from 'components/Alert/AlertsComponent';
import allItemsOutOfStock from 'utilities/sku/isAllOptionsOutOfStock';
import { StockCode } from 'types/ProductResponseType';
import AddToBasketButton from './AddToBasketButton';
import StickyAddToBasketButton from './StickyAddToBasketButton';

function AddToBasket() {
  const {
    errorMessage,
    handleDigitalDownloadDialogueRender,
    handleAddToBasket,
    hasError,
    digitalDownload,
    skus,
    selectedSku,
  } = useSelectedSkuContext();
  const primaryAddToBasketButtonRef = useRef<HTMLDivElement>(null);
  const isDisabled =
    allItemsOutOfStock(skus) ||
    selectedSku?.stock?.code === StockCode.OUTOFSTOCK ||
    selectedSku?.stock?.code === StockCode.UNAVAILABLE;

  return (
    <div data-cnstrc-btn="add_to_cart" data-testid="add-to-basket">
      {hasError && (
        <GridRow>
          <GridItem xxs={12}>
            <AlertsComponent errorMessage={errorMessage} />
          </GridItem>
        </GridRow>
      )}

      <AddToBasketButton
        ref={primaryAddToBasketButtonRef}
        handleAddToBasket={digitalDownload ? handleDigitalDownloadDialogueRender : handleAddToBasket}
        disabled={isDisabled}
      />

      <StickyAddToBasketButton
        primaryAddToBasketButtonRef={primaryAddToBasketButtonRef}
        handleAddToBasket={digitalDownload ? handleDigitalDownloadDialogueRender : handleAddToBasket}
        disabled={isDisabled}
      />
    </div>
  );
}

export default AddToBasket;
